import type { CityConfig } from "@/pages/city-template/types";

export const stamfordConfig: CityConfig = {
  city: "Stamford",
  state: "Connecticut",
  stateAbbr: "CT",
  slug: "stamford",
  route: "/cities/stamford",
  title: "Emergency Passport Stamford, CT — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription:
    "Get your passport fast in Stamford, CT. Fast Passport Center offers 24-hour to 10-day expedited passport processing. Registered State Department courier serving Stamford and all of Connecticut.",
  h1: "Expedited Passport Services in Stamford, CT",
  heroSubtitle:
    "Stamford's business community and commuting families need passport service that works on their schedule. Fast Passport Center delivers emergency and expedited passports as fast as 24 hours.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Modern%20skyline%20of%20Stamford%20Connecticut%20featuring%20contemporary%20skyscrapers%20and%20harbor%2C%20warm%20evening%20lighting%20reflecting%20on%20Long%20Island%20Sound%2C%20clean%20urban%20waterfront%20with%20professional%20architecture%2C%20professional%20travel%20destination%20photography%2C%20no%20text%20overlay%2C%20no%20people%20visible&width=1600&height=700&seq=ct-stam-hero-001&orientation=landscape",
  heroImageAlt: "Downtown Stamford Connecticut modern skyline at evening",
  geoPosition: "41.0534; -73.5387",
  geoPlacename: "Stamford, Connecticut, United States",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Connecticut Passport Agency",
    address: "850 Canal Street, Stamford, CT 06902",
    distance: "Approximately 170 miles, 2.5 hours via I-90",
  },
  nearbyCitiesZips: [
    { name: "Stamford", zips: "06901, 06902, 06903, 06904, 06905, 06906, 06907, 06910, 06911, 06912, 06913, 06914, 06920, 06921, 06922, 06925, 06926, 06927" },
    { name: "Norwalk", zips: "06850, 06851, 06852, 06853, 06854, 06855, 06856, 06857, 06858, 06859, 06860" },
    { name: "Greenwich", zips: "06830, 06831, 06836, 06870, 06878" },
    { name: "Darien", zips: "06820" },
    { name: "New Canaan", zips: "06840" },
    { name: "Wilton", zips: "06897" },
    { name: "Westport", zips: "06880, 06881, 06888, 06889" },
    { name: "Fairfield", zips: "06824, 06825, 06828" },
    { name: "Bridgeport", zips: "06601, 06602, 06604, 06605, 06606, 06607, 06608, 06610, 06650, 06673, 06699" },
    { name: "Trumbull", zips: "06611" },
    { name: "Monroe", zips: "06468" },
    { name: "Shelton", zips: "06484" },
    { name: "Ridgefield", zips: "06877" },
    { name: "Redding", zips: "06896" },
    { name: "Easton", zips: "06612" },
    { name: "Weston", zips: "06883" },
    { name: "Bethel", zips: "06801" },
    { name: "Danbury", zips: "06810, 06811, 06813, 06814, 06816, 06817" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency processing available for Stamford travelers with urgent departure dates.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with reserved agency submission slots.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Serving All of Stamford",
      desc: "Downtown, Shippan, North Stamford, Springdale, Glenbrook — we cover every Stamford neighborhood.",
    },
  ],
  testimonials: [
    {
      name: "David C.",
      location: "Stamford, CT",
      rating: 5,
      text: "As a financial executive with sudden business travel to London, I needed my passport renewed fast. Fast Passport Center had it back in 4 days. Their Stamford service is exceptional.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah P.",
      location: "Greenwich, CT",
      rating: 5,
      text: "I needed an emergency passport for my daughter's study abroad program in Barcelona. Fast Passport Center processed everything in 3 days. We were so relieved.",
      service: "Child Passport",
    },
    {
      name: "James L.",
      location: "Norwalk, CT",
      rating: 5,
      text: "Lost my passport two weeks before a Caribbean vacation. Fast Passport Center got me a replacement in 5 days. I made my trip with time to spare.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "stam-1",
      name: "Stamford Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "421 Atlantic Street",
      city: "Stamford",
      state: "CT",
      zip: "06901",
      phone: "203-348-4512",
      hours: "Mon-Fri 9:00 AM - 4:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Stamford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "stam-2",
      name: "Stamford City Clerk",
      type: "City Clerk / Passport Services",
      address: "888 Washington Boulevard",
      city: "Stamford",
      state: "CT",
      zip: "06901",
      phone: "203-977-4058",
      hours: "Mon-Fri 8:00 AM - 4:30 PM",
      distance: "Downtown Stamford",
      website: "https://www.stamfordct.gov/",
      websiteLabel: "City of Stamford",
      notes: "Provides passport application acceptance services. Appointment recommended for all passport services.",
      icon: "ri-government-line",
    },
    {
      id: "stam-3",
      name: "Norwalk Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "16 Washington Street",
      city: "Norwalk",
      state: "CT",
      zip: "06854",
      phone: "203-866-6514",
      hours: "Mon-Fri 9:00 AM - 4:00 PM",
      distance: "Norwalk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport photo services and application acceptance available. Appointment recommended for passport applications.",
      icon: "ri-file-shield-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get a passport in Stamford, CT?",
      a: "Fast Passport Center offers processing options from 24 hours to 10 business days. For emergency travel within 2 weeks, we recommend our 3-5 day or 24-hour emergency service. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Is the Connecticut Passport Agency close to Stamford?",
      a: "The Connecticut Passport Agency is approximately 35 miles south of Stamford, accessible via I-95 or Metro-North train. However, if you use Fast Passport Center, you don't need to visit the agency at all. We handle the agency submission for you as a registered courier.",
    },
    {
      q: "Where can I get passport photos in Stamford?",
      a: "Passport photos are available at CVS Pharmacy, Walgreens, UPS Store, FedEx Office, and Walmart locations throughout Stamford, Greenwich, and Norwalk. We also offer photo review as part of our service to ensure your photos meet all State Department requirements before submission.",
    },
    {
      q: "Can I renew my passport by mail from Stamford?",
      a: "Yes, if your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged. Mail renewal takes 8-11 weeks. For faster renewal, Fast Passport Center can expedite the process to as little as 3-5 days.",
    },
    {
      q: "What documents do I need for a first-time passport in Stamford?",
      a: "You'll need proof of U.S. citizenship (birth certificate or naturalization certificate), a government-issued photo ID, two passport photos, and payment for government fees. Fast Passport Center provides a complete checklist and reviews your documents before submission.",
    },
    {
      q: "Does Fast Passport Center have an office in Stamford?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Stamford. We serve Stamford and all of Connecticut through our secure document shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Stamford", address: " various CVS locations in Stamford", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Stamford", address: "various Walgreens locations in Stamford", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Stamford", address: "various UPS Store locations in Stamford", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Stamford", address: "various FedEx Office locations in Stamford", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart — Stamford", address: "various Walmart locations in Stamford", hours: "Mon-Sun 7:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "CT DMV — Norwalk",
      address: "540 Main Avenue, Norwalk, CT 06851",
      hours: "Mon-Fri 8:00 AM - 4:00 PM",
      note: "Full DMV services for Fairfield County residents. Appointments strongly recommended.",
      featured: true,
    },
    {
      name: "CT DMV — Bridgeport",
      address: "95 Freight Street, Bridgeport, CT 06610",
      hours: "Mon-Fri 8:00 AM - 4:00 PM",
      note: "License renewals and REAL ID applications for Bridgeport and surrounding areas.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "HPN",
      name: "Westchester County Airport",
      distance: "~10 miles from Stamford",
      address: "240 Airport Rd, White Plains, NY 10604",
      note: "The closest airport to Stamford with domestic flights and some international connections. Popular for Fairfield County travelers.",
      flightUrl: "https://www.airport.westchestergov.com/",
      flightLabel: "Westchester County Airport",
      featured: true,
    },
    {
      code: "JFK",
      name: "JFK International Airport",
      distance: "~35 miles from Stamford",
      address: "JFK Access Rd, Queens, NY 11430",
      note: "Major international hub with flights to virtually every global destination. Metro-North and Amtrak connections available from Stamford.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK International",
      featured: false,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "~30 miles from Stamford",
      address: "Queens, NY 11371",
      note: "Domestic and international flights. Accessible via I-95 south from Stamford. Popular for business travelers.",
      flightUrl: "https://www.laguardiaairport.com/",
      flightLabel: "LaGuardia Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Stamford travelers with urgent departures within 24 hours to 2 weeks. Reserved agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Stamford residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Stamford residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Stamford residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Stamford, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Stamford residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Stamford travelers with immediate departure needs." },
    { name: "Passport Renewal", description: "Fast passport renewal for Stamford residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Stamford residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Stamford residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Stamford." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Stamford." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Stamford travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Stamford travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Stamford-area team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application with reserved agency processing slots.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Stamford address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 35 miles to NYC, visit in person area", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Weekend Availability", agency: "No — business hours only", fpc: "Yes — we work weekends for urgent cases" },
    { feature: "Photo Review", agency: "No — your problem if rejected", fpc: "Yes — pre-submission verification" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Hartford", route: "/cities/hartford" },
    { name: "New Haven", route: "/cities/new-haven" },
    { name: "Bridgeport", route: "/cities/bridgeport" },
    { name: "Waterbury", route: "/cities/waterbury" },
    { name: "Greenwich", route: "/cities/greenwich" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Stamford and all of Connecticut as a remote courier service. We do not have a physical office in Stamford, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeAddress: "850 Canal Street, Stamford, CT 06902",
  fpcOfficeDistance: "Remote courier service — Stamford, CT area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to all Stamford neighborhoods and surrounding Fairfield County communities. From downtown Stamford to Shippan, North Stamford to Springdale — we serve every Stamford neighborhood with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Stamford and all surrounding Fairfield County communities. Whether you're in the financial district or a nearby suburb, our expedited passport services are available to you with the same speed and reliability.",
  howItWorksIntro:
    "Our Stamford customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Stamford travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Stamford and Connecticut travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about expedited passport services in Stamford, CT. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/connecticut",
  statePageName: "Connecticut Passport Services",
  dmvWebsite: "https://portal.ct.gov/DMV",
  dmvLabel: "Connecticut DMV — Official Website",
  vitalRecordsLinks: [
    { icon: "ri-user-heart-line", label: "Birth Certificates — Connecticut DPH", desc: "Request certified Connecticut birth certificates from the Department of Public Health Vital Records Office. Available by mail, online, or in person.", url: "https://portal.ct.gov/DPH/Vital-Records/Vital-Records-Home" },
    { icon: "ri-file-history-line", label: "Death Certificates — Connecticut DPH", desc: "Obtain certified Connecticut death certificates through the DPH Vital Records Office. Mail, online, and in-person options available.", url: "https://portal.ct.gov/DPH/Vital-Records/Vital-Records-Home" },
    { icon: "ri-heart-pulse-line", label: "Marriage Certificates — Stamford Town Clerk", desc: "Request certified marriage certificates from the Stamford Town Clerk's Office. Marriage records are maintained by the town where the ceremony took place.", url: "https://www.stamfordct.gov/government/town-clerk" },
    { icon: "ri-scales-line", label: "Divorce Records — Stamford Superior Court", desc: "Obtain certified divorce decrees from the Stamford Judicial District Superior Court. Divorce records are maintained by the court where the decree was granted.", url: "https://jud.ct.gov/" },

  ],
};

export default stamfordConfig;